/**
 * @fileoverview Agent definition for world-system-details-ideation-v3.
 *
 * This agent generates creative directions for developing a world system's details.
 * The user selects one direction before full details are generated.
 *
 * @category world-building.systems.details
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-system-details-ideation-v3',
  kind: 'primitive',
  name: 'World System Details Ideation',
  description: 'Generates creative directions for developing a world system before full detail generation.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.systems.details',
    usedBy: ['use-world-system-details-ideation-v3.ts'],
    usedInComposites: [],
    relatedAgents: ['world-system-details-generator-v3'],
  },
};
